import React, { Component } from 'react';

import ImageMapper from 'react-img-mapper';
import { get_points_for_card, SPECIAL_GUESTS } from '../../Common/CardUtilities';
import Grid2d from '../../Common/Grid2d';
import { getCardTextureId, getCardTextureUrl, getFactionTextureId, getFactionTextureUrl, getTextureUrl } from '../../Common/TextureTools';
import './hotel-interface.css';
import './inventory-selector.css';
import '../../Controls/competitor-board.css';

import '../Views/robots.css';
import MessageDisplay from '../../Controls/MessageDisplay';
import { RobotMarket } from '../Views/RobotComponents';
import ScoreBars from '../Views/ScoreBars';


import blankImage from '../../Common/blank-512x512.png'
import { ASSETS_URL } from '../../../../Settings';


// Master robot-size multiplier. Scales EVERY robot on the board together —
// the spinning activated-room robots and the non-spinning market/storage
// robots — so they all stay the same visual size relative to each other.
// Bump this to make robots bigger everywhere. (The spin *radius* is a
// separate knob, `orbitFactor`, inside ActivatedRoom.)
const ROBOT_SCALE = 3;


class FactionIndicator extends Component {
    render() {
        let gamePlayerData = this.props.gamePlayerData;
        let factionId = gamePlayerData.faction;
        let src;
        if (factionId) {
            src = getFactionTextureUrl(factionId);
        } else {
            src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
        }


        return <div>
            <img
                src={src}
                alt="room"
                data-tname={factionId ? getFactionTextureId(factionId) : undefined}
                width={this.props.radius * 2.26}
                height={this.props.radius * 2.26}
                style={{position: 'absolute', top: this.props.offsetTop, left: this.props.offsetLeft}}
            />
        </div>;

    }
}


class ActivatedRoom extends Component {
    constructor(props) {
        super(props);
        this.src = getTextureUrl(157);
    }
    render() {
        const src = this.src;
        const activatedCount = this.props.activated;
        const locked = this.props.locked;
        let baseClassName = 'activated-robot';
        let parentClassName = 'activated-robot-parent'
        if (!locked) {
            baseClassName += ' animate-robot'
            parentClassName += ' animate-robot-parent'
        }

        // Size and orbit radius are genuinely independent knobs:
        //   robotWidth  — how big each robot is (driven by ROBOT_SCALE, the
        //                 board-wide multiplier so spinners match the
        //                 non-spinning market/storage robots).
        //   orbitFactor — how far each robot rides from the spin center,
        //                 in multiples of a robot width. Bigger = wider ring,
        //                 more gap between robots. This is what was missing:
        //                 the old corner-pinning locked the radius to the
        //                 robot's own half-width, so robots piled on the
        //                 center no matter how big they got.
        const orbitFactor = 0.3;
        const robotWidth = (this.props.width / 4) * ROBOT_SCALE;
        const orbitRadius = robotWidth * orbitFactor;

        // The parent fills the room and spins around its center (CSS
        // transform-origin: center). We place each robot on the ring with
        // top/left, leaving `transform` free for the per-robot counter-spin
        // that keeps it upright. First robot at the top, rest evenly spaced.
        const parentSize = this.props.width;
        const center = parentSize / 2;
        const count = Math.min(activatedCount, 3);

        const robots = [];
        for (let i = 0; i < count; i++) {
            const angle = (-90 + i * (360 / count)) * (Math.PI / 180);
            const left = center + orbitRadius * Math.cos(angle) - robotWidth / 2;
            const top = center + orbitRadius * Math.sin(angle) - robotWidth / 2;
            robots.push(
                <div key={i} className={baseClassName} style={{ top, left }}>
                    <img
                        src={src}
                        alt="robot"
                        className={'activated-room-robot'}
                        style={{ width: robotWidth }}
                    />
                </div>
            );
        }

        return <div className={'robot-activated-room-container'}>

            <div className={parentClassName}
                style={{
                    width: parentSize,
                    height: parentSize,
                    top: 0,
                    left: 0,
                }}
            >
                {robots}
            </div>
        </div>;
    }
}


class StationRoom extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
    }

    toggleActivation = (roomIndex) => {
        this.props.app.game.seatedController.gamePlayerApi.toggleActivation(roomIndex);
    }

    onClick = (item) => {
        console.log('click')
        let gamePlayerData = this.props.gamePlayerData;
        let roomIndex = this.props.roomIndex;
        let station = gamePlayerData.station;
        let roomId = station[roomIndex];
        let locked = false;
        if (roomId && gamePlayerData.locked_rooms.includes(roomIndex)) {
            locked = true;
        }
        let highlight = false;
        if (this.props.highlightedRooms.includes(roomIndex)) {
            highlight = true;
        }
        console.log('station room click', roomIndex)
        if (highlight) {
            this.props.callback(roomIndex);
        } else if (roomId && !locked) {
            this.toggleActivation(roomIndex);
        }
        // this.clear();
    }

    // clear = () => {
    //     this.myRef.current.clearHighlightedArea();
    // }

    assignRef = (ref) => {
        this.ref = ref;
    }

    render() {
        let gamePlayerData = this.props.gamePlayerData;
        let station = gamePlayerData.station;
        let roomIndex = this.props.roomIndex;
        let roomId = station[roomIndex];
        let src;
        if (roomId) {
            src = getTextureUrl(roomId);
        } else {
            src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
        }

        let highlight = false;
        if (this.props.highlightedRooms.includes(roomIndex)) {
            highlight = true;
        }

        let activated = false;
        if (gamePlayerData.robot_assignments.includes(roomIndex)) {
            activated = gamePlayerData.robot_assignments.filter(assignment => assignment === roomIndex).length;
        }
        let locked = false;
        if (roomId && gamePlayerData.locked_rooms.includes(roomIndex)) {
            locked = true;
        }
        const AREAS = [{
            "shape": "circle",
            "coords": [256,256,200],
            "fillColor": "rgba(143,143,143,0.44)"
        }];

        const MAP = {
            name: `workmap-${roomIndex}`,
            areas: AREAS
        }

        return <div ref={this.assignRef}
                    data-tname={roomId || undefined}>
            <ImageMapper src={src} map={MAP}
                         onClick={this.onClick}
                         width={this.props.width}
                         height={this.props.width}
                         imgWidth={512}
                         stayHighlighted={false}
                         stayMultiHighlighted={false}
                         toggleHighlighted={false}
                         containerRef={this.myRef}
                         rerenderProps={[]}
            />
            {highlight && <div className={'inventory-highlighter '}/>}
            {activated && <ActivatedRoom activated={activated} locked={locked} onClick={this.onClick} {...this.props} />}
            {locked && <div className={'hotel-interface-locked-room'} />}
        </div>;
    }
}

class DockCard extends Component {
    // this is mislableled it is actually left.
    onClick = () => {
        console.log('CLICK')
    }

    render() {
        let gamePlayerData = this.props.gamePlayerData;
        let docks = gamePlayerData.docks;
        let dockIndex = this.props.dockIndex;
        let cardId = docks[dockIndex];

        // let points = gamePlayerData.docks_extended[dockIndex];
        let station = gamePlayerData.station;
        let robot_assignments = gamePlayerData.robot_assignments;
        let lodging = gamePlayerData.lodging;
        let calculatedPoints = get_points_for_card(
            station, robot_assignments, lodging, cardId, dockIndex);
        // if (calculatedPoints.satisfied) {
        //     if (calculatedPoints.points !== points) {
        //         console.error('Point Miscalculation.', cardId, points, calculatedPoints.points, calculatedPoints.statement);
        //     }
        // }
        let points = calculatedPoints.points;
        let isDanger = points === 'Danger';
        let pointsClassName = 'docked-card-points';
        if (isDanger) {
            pointsClassName += ' docked-card-points--danger';
        }

        let src;
        if (cardId) {
            src = getCardTextureUrl(cardId);
        } else {
            src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
        }
        let highlight = false;
        if (this.props.highlightedDocks.includes(dockIndex)) {
            highlight = true;
        }

        let cardWidth = this.props.width / 3.33;
        let cardHeight = cardWidth / 1.4;

        let style = {width: cardWidth, height: cardHeight};
        let offset = '0.23%'
        if (dockIndex === 0) style['top'] = offset;
        if (dockIndex === 0) style['right'] = offset;
        if (dockIndex === 1) style['right'] = offset;
        if (dockIndex === 1) style['bottom'] = offset;
        if (dockIndex === 2) style['left'] = offset;
        if (dockIndex === 2) style['bottom'] = offset;
        if (dockIndex === 3) style['left'] = offset;
        if (dockIndex === 3) style['top'] = offset;

        return <div id={`dock-${dockIndex}`}
                    className={'dock'}
                    style={style}
        >
            <div id={'dock-card'} className={'docked-card-container'}>
                <img
                    src={src}
                    title={calculatedPoints.statement}
                    alt="card"
                    className={'docked-card'}
                    data-tname={cardId ? getCardTextureId(cardId) : undefined}
                    onClick={() => {
                        if (highlight) {
                            this.props.callback(dockIndex);
                        } else {
                            this.onClick();
                        }
                    }}
                />
                {highlight && <div className={'highlighted-docked-card dock-animated-border-dashed'} />}
                {points !== 0 && <div id={'docked-card-points'}
                                      className={pointsClassName}>
                    {!isDanger && <div id={'docked-card-point-text'}
                                       className={'docked-card-point-text'}>{points}</div>}
                </div>
                }
            </div>
        </div>;
    }
}

class StaffMarket extends Component {

    constructor(props) {
        super(props);
        this.state = {
            width: 500,
            height: 500*1.144,
            radius: 500*0.1
        };
        this.grid = new Grid2d(40, false);
        this.element = null;
        this.fillGrid();
    }

    componentDidMount() {
        this.setWidth();
        this.resizeObserver = new ResizeObserver(this.setWidth);
        this.resizeObserver.observe(this.element);
    }

    componentWillUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    setWidth = () => {
        let width = this.element.offsetWidth;
        let height = width * 1.144;
        let radius = width * 0.35;
        this.grid.updateRadius(radius);
        this.setState({ width: width, height: height, radius: radius},
            () => {
                this.fillGrid();
            });
    }

    item = (robotId) => {
        if (!robotId) return <></>;
        let textureId = 157;
        return <img
            src={getTextureUrl(textureId)}
            alt="robot"
            // The grid anchors items by their top-left corner at the hex
            // point, so a wider img drifts down-right. Pull it back by half
            // its own size to sit centered on the hex point at any scale.
            style={{ width: this.state.radius * 2 * ROBOT_SCALE,
                     transform: 'translate(-50%, -50%)' }}
        />;
    };

    fillGrid = () => {
        this.props.gamePlayerData.robot_market.forEach((robotId, index) => {
            this.grid.moveItemToGridId(this.item(robotId), index);
        });
    };

    getGrid = () => {
        this.fillGrid();
        return this.grid.render();
    }


    render() {
        return <div className={'staff-market-anchor'} ref={(ref) => {this.element=ref}}>
            <div className={'staff-market-container'}>
                {this.getGrid()}
            </div>
        </div>;
    }
}

class AvailableStaff extends Component {

    constructor(props) {
        super(props);
        this.state = {
            width: 500,
            height: 500*1.144,
            radius: 500*0.1
        };
        this.grid = new Grid2d(40, false);
        this.element = null;
        this.fillGrid();
    }

    componentDidMount() {
        this.setWidth();
        this.resizeObserver = new ResizeObserver(this.setWidth);
        this.resizeObserver.observe(this.element);
    }

    componentWillUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    setWidth = () => {
        let width = this.element.offsetWidth;
        let height = width * 1.144;
        let radius = width * 0.35;
        this.grid.updateRadius(radius);
        this.setState({ width: width, height: height, radius: radius},
            () => {
                this.fillGrid();
            });
    }

    item = (robotId) => {
        if (!robotId) return <></>;
        let textureId = 157;
        return <img
            src={getTextureUrl(textureId)}
            alt="robot"
            // The grid anchors items by their top-left corner at the hex
            // point, so a wider img drifts down-right. Pull it back by half
            // its own size to sit centered on the hex point at any scale.
            style={{ width: this.state.radius * 2 * ROBOT_SCALE,
                     transform: 'translate(-50%, -50%)' }}
        />;
    };

    fillGrid = () => {
        this.props.gamePlayerData.robot_storage.forEach((robotId, index) => {
            this.grid.moveItemToGridId(this.item(robotId), index);
        });
    };

    getGrid = () => {
        this.fillGrid();
        return this.grid.render();
    }


    render() {
        return <div className={'staff-market-anchor'} ref={(ref) => {this.element=ref}}>
            <div className={'staff-market-container'}>
                {this.getGrid()}
            </div>
        </div>;
    }
}


export default class HotelInterface extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: 500,
            height: 500*1.144,
            radius: 500*0.1,
            highlightedDocks: [],
            highlightedRooms: [],
            highlightedLodging: [],
            callback: null,
        };

        this.interface = null;
        this.grid = new Grid2d(27, true);
        this.fillGrid();
    }

    componentDidMount() {
        this.setWidth();
        this.resizeObserver = new ResizeObserver(this.setWidth);
        this.resizeObserver.observe(this.interface);
        window.addEventListener('highlight-docks-event',
            this.highlightDocksEvent);
        window.addEventListener('clear-docks-highlight-event',
            this.clearDocksEvent);
        window.addEventListener('highlight-rooms-event',
            this.highlightRoomsEvent);
        window.addEventListener('clear-rooms-highlight-event',
            this.clearRoomsEvent);
        window.dispatchEvent(new Event('hotel-interface-mounted-event'));
    }

    componentWillUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
        window.removeEventListener('highlight-docks-event',
            this.highlightDocksEvent);
        window.removeEventListener('clear-docks-highlight-event',
            this.clearDocksEvent);
        window.removeEventListener('highlight-rooms-event',
            this.highlightRoomsEvent);
        window.removeEventListener('clear-rooms-highlight-event',
            this.clearRoomsEvent);
    }

    setWidth = () => {
        let width = this.interface.offsetWidth;
        let height = width * 1.144;
        let radius = width * 0.108;
        this.grid.updateRadius(radius);
        this.setState({ width: width, height: height, radius: radius},
            () => {
                this.fillGrid();
        });
    }

    fillGrid = () => {
        let station = [ 1, 2, 3, 4, 5, 6, ];
        let beds = [ 9, 11, 15, 17];
        // let lodging = [ 31, 15, 14, 12, 11, 25 ];
        // let docks = [56, 58, 40, 42];
        // let docks = [33, 35, 21, 23];
        let total = [ ...station, ...beds ];
        total.forEach((gridId, index) => {
            // let element = this.room(index);
            let element = <StationRoom {...this.props}
                                       roomIndex={index}
                                       width={this.state.radius * 2.26}
                                       highlightedDocks={this.state.highlightedDocks}
                                       highlightedRooms={this.state.highlightedRooms}
                                       highlightedLodging={this.state.highlightedLodging}
                                       callback={this.state.callback}
            />
            this.grid.moveItemToGridId(element, gridId);
        });
        // this.grid.moveItemToGridId(this.card(), 33);
        // this.grid.moveItemToGridId(this.card(), 35);
        // this.grid.moveItemToGridId(this.card2(), 21);
        // this.grid.moveItemToGridId(this.card2(), 23);
    };

    getGrid = () => {
        this.fillGrid();
        return this.grid.render();
    }


    highlightDocksEvent = (e) => {
        this.setState({...e.detail});
    }

    clearDocksEvent = (e) => {
        this.setState({highlightedDocks: [], callback: null});
    }

    highlightRoomsEvent = (e) => {
        this.setState({...e.detail});
    }

    clearRoomsEvent = (e) => {
        this.setState({highlightedRooms: [], callback: null});
    }

    highlightDocks = (docks, callback) => {
        this.setState({
            highlightedDocks: docks, callback: callback});
    }

    highlightRooms = (stationIndexes, callback) => {
        this.setState({
            highlightedRooms: stationIndexes, callback: callback});
    }

    clearAll = (shortCallback) => {
        this.setState({
            highlightedDocks: [],
            highlightedRooms: [],
            callback: null
        }, shortCallback)
    }

    callback = (data) => {
        let longCallback = this.state.callback;
        this.clearAll(() => {
            if (longCallback) longCallback(data);
        });
    }


    render() {
        const AREAS = [{
            "shape": "circle",
            "coords": [30,30,27],
            "fillColor": "rgba(143,143,143,0.44)"
        }];

        const MAP = {
            name: `hotel-map`,
            areas: AREAS
        }

        let offsetTop = -1.132 * this.state.radius;
        let offsetLeft = -1.135 * this.state.radius;
        return (<>
            <div id={'hotel-interface'} className={'hotel-interface'} ref={(ref) => {this.interface=ref}}>
                <div id={'hotel-center'} className={'hotel-center'}>
                    <div style={{position: 'absolute', top: offsetTop, left: offsetLeft}}>
                        {this.getGrid()}
                    </div>
                </div>
                <div id={'hotel-center'} className={'hotel-center'}>
                    <FactionIndicator {...this.props} {...this.state} offsetTop={offsetTop} offsetLeft={offsetLeft}/>
                </div>
                <div id={'docks'} className={'docks'}>
                    <DockCard {...this.props} {...this.state} dockIndex={0}/>
                    <DockCard {...this.props} {...this.state} dockIndex={1}/>
                    <DockCard {...this.props} {...this.state} dockIndex={2}/>
                    <DockCard {...this.props} {...this.state} dockIndex={3}/>
                </div>
                <div id={'staff'} className={'hotel-interface-staff-market'}>
                    <StaffMarket {...this.props} {...this.state} />
                </div>
                <div id={'staff'} className={'hotel-interface-available-staff'}>
                    <AvailableStaff {...this.props} {...this.state} />
                </div>
                <div id={'score'} className={'hotel-interface-score-bars'}>
                    <ScoreBars {...this.props} {...this.state}/>
                </div>
                <img
                    id={'hotel-interface-background'}
                    src={`${ASSETS_URL}ui/HotelGridSVG_004.svg`}
                    alt="action"
                    className={'hotel-interface-background'}
                />
            </div>
            </>
        )
    }
}
